import React from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function FloodEventExplainer({ fontSize, typicalRangeHigh }) {
	let fontSizeComputed = "0.7em";
	if(fontSize) {
		fontSizeComputed = fontSize;
	}


	return <Row>
		<Col xs={12}>
			<span style={{fontSize: fontSizeComputed}}>
				A flood event for this station is defined as a period of time where the water level exceeds <b>{typicalRangeHigh}m</b>. A flood event is not deemed over until the station remains below this level for 24 hours.
			</span>
		</Col>
	</Row>;

}


export default FloodEventExplainer;